import * as React from "react"

/**
 * Labels for all UI package components.
 * Provide once (e.g. from app i18n) via UILabelsProvider; components read their slice.
 */
export interface UILabels {
  multiPick: {
    placeholder: string
    emptyMessage: string
    itemsLabel: string
    searchPlaceholder: string
    createItemLabel: string
    clearSearchTooltip?: string
    clearSelectionsTooltip?: string
  }
  copyableText: {
    copiedToast: string
  }
}

const UILabelsContext = React.createContext<UILabels | null>(null)

export const UILabelsProvider = UILabelsContext.Provider

export function useUILabels(): UILabels {
  const context = React.useContext(UILabelsContext)
  if (!context) {
    throw new Error('useUILabels must be used within a UILabelsProvider')
  }
  return context
}
